import React, {useState, useEffect, useRef} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_ServiceListComponent from "../components/_FM_service/_FM_ServiceListComponent";
import _FM_ServiceFormComponent from "../components/_FM_service/_FM_ServiceFormComponent";
import _FM_ServiceShowComponent from "../components/_FM_service/_FM_ServiceShowComponent";
import HelpComponent from "../components/HelpComponent";

const _FM_ServicePage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id,action} = useParams();

  useEffect(() => {
    document.title = t('services') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/service')
  }, []);

  useEffect(() => {
    if(!action) {
      window.App.setState({
        sidebarServiceForm: false,
        sidebarServiceShow: false,
      })
    }
    if(action === 'create'){
      window.App.setState({
        sidebarServiceForm: true,
      })
    }
    if(id && action === 'read'){
      window.App.setState({
        sidebarServiceForm: true,
      })
    }
    if(id && action === 'update'){
      window.App.setState({
        sidebarServiceForm: true,
      })
    }
  }, [id, action]);

  return (
    <div className="_FM_ServicePage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/service"}/>
      <Panel>
        <_FM_ServiceListComponent />
      </Panel>
      <Sidebar position="right" visible={action === 'update' || action === 'create'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/service');
               }}>
        <_FM_ServiceFormComponent />
      </Sidebar>
      <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/service');
               }}>
        <_FM_ServiceShowComponent />
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(_FM_ServicePage);
